const getColorChatUser = (layoutMode) => {
    switch (layoutMode) {
        case "dark":
            return { theme: "#16140E", background: "#F9F5ED" };
        case "eclipse":
            return { theme: "#F9F5ED", background: "#16140E" };
        case "light":
            return { theme: "#16140E", background: "#FFD370" };
        default:
            return { theme: "#16140E", background: "#FFD370" };
    }
};

export default getColorChatUser;
